import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.29_better-sqlite3@11.10.0_db0@0.3.2_bette_pl56kyq2wjk75b3rf64ctsdave/node_modules/nuxt/dist/pages/runtime/validate.js";
import sanctum_58auth_58global from "/vercel/path0/node_modules/.pnpm/nuxt-auth-sanctum@0.6.7/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.global.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.29_better-sqlite3@11.10.0_db0@0.3.2_bette_pl56kyq2wjk75b3rf64ctsdave/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  sanctum_58auth_58global,
  manifest_45route_45rule
]
export const namedMiddleware = {}